import { combineReducers } from 'redux';

import classificacoes from './classificacoes/reducer';

export default combineReducers({
	classificacoes,
});
